import { Input, Modal, Radio, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';

interface RejectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (remark: string) => void;
}

const RejectDialog = ({ isOpen, onClose, onConfirm }: RejectDialogProps) => {
  const [value, setValue] = useState<string>('');
  const [textValue, setTextValue] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      setValue('');
      setTextValue('');
    }
  }, [isOpen]);

  const handleOk = () => {
    switch (value) {
      case 'notClear':
        onConfirm('画框清晰度不够');
        break;
      case 'notFrame':
        onConfirm('不是画框');
        break;
      case 'notName':
        onConfirm('画框名称不合规');
        break;
      case 'other':
        onConfirm(textValue);
        break;
    }
  };

  const confirmDisabled = useMemo(() => {
    return value === 'other' ? textValue === '' : !value;
  }, [value, textValue]);

  return (
    <Modal
      open={isOpen}
      title="不通过原因"
      width={500}
      onCancel={onClose}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      okButtonProps={{
        disabled: confirmDisabled,
        danger: true,
      }}
      destroyOnClose
    >
      <Radio.Group
        onChange={(e) => {
          setValue(e.target.value as string);
          setTextValue('');
        }}
        value={value}
        style={{ marginBottom: 10 }}
      >
        <Space direction="vertical">
          <Radio value="notClear">画框清晰度不够</Radio>
          <Radio value="notFrame">不是画框</Radio>
          <Radio value="notName">画框名称不合规</Radio>
          <Radio value="other">其他</Radio>
        </Space>
      </Radio.Group>

      <Input.TextArea
        placeholder="请输入不通过原因"
        rows={4}
        disabled={value !== 'other'}
        value={textValue}
        onChange={(e) => setTextValue(e.target.value)}
      />
    </Modal>
  );
};

export default RejectDialog;
